import React, { createContext, useContext, useState, useCallback } from 'react';

interface AudioContextType {
  currentlyPlayingId: string | null;
  setCurrentlyPlayingId: (id: string | null) => void;
  userPlayingId: string | null;
  setUserPlayingId: (id: string | null) => void;
  isAudioPlaying: boolean;
  setIsAudioPlaying: (isPlaying: boolean) => void;
  visualizerState: 'default' | 'speaking' | 'playing';
  setVisualizerState: (state: 'default' | 'speaking' | 'playing') => void;
}

const AudioContext = createContext<AudioContextType | undefined>(undefined);

export const AudioStateProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [currentlyPlayingId, setCurrentlyPlayingId] = useState<string | null>(null);
  const [userPlayingId, setUserPlayingId] = useState<string | null>(null);
  const [isAudioPlaying, setIsAudioPlaying] = useState(false);
  const [visualizerState, setVisualizerState] = useState<'default' | 'speaking' | 'playing'>('default');

  return (
    <AudioContext.Provider
      value={{
        currentlyPlayingId,
        setCurrentlyPlayingId,
        userPlayingId,
        setUserPlayingId,
        isAudioPlaying,
        setIsAudioPlaying,
        visualizerState,
        setVisualizerState,
      }}
    >
      {children}
    </AudioContext.Provider>
  );
};

export const useAudioState = () => {
  const context = useContext(AudioContext);
  if (!context) {
    throw new Error('useAudioState must be used within an AudioStateProvider');
  }
  return context;
};
